import React from "react";
import { Modal, Button, Accordion } from "react-bootstrap";
import { Link } from "react-router-dom";

const CallDetails = ({ show, handleClose, call }) => {
  if (!call) {
    return null;
  }

  const transcriptData = call.transcription || [];

  return (
    <Modal show={show} onHide={handleClose} centered size="xl">
      <Modal.Header closeButton>
        <Modal.Title className="fs-three bg-light-subtle">
          Call Detail
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          {/* Left Section */}
          <div className="col-md-8 mt-3">
            {/* Summary */}
            <div className="card p-4 mb-4 border-light-subtle shadow-sm bg-light-subtle">
              <h6 className="fw-bold">Summary of the call</h6>
              <hr className="border-dark-subtle" />
              <p className="my-2">{call.transcriptionSummary || "NA"}</p>
              {/* Recording */}
              <div className="py-3">
                <h6 className="fw-bold my-3">Recording</h6>
                <div className="audio-player position-relative py-5">
                  <audio controls className="  ">
                    <source src="audio-sample.mp3" type="audio/mpeg" />
                    Your browser does not support the audio element.
                  </audio>
                  <div className="custom-controls position-absolute">
                    <img
                      src="/assets/audio-play.svg"
                      alt="Play"
                      className="img-fluid"
                    />
                  </div>
                </div>
                <div className="d-flex justify-content-between align-items-center my-3">
                  <div className="d-flex align-items-center">
                    <img src="/assets/flag.svg" alt="Info" className="me-2" />
                    <Link
                      to=""
                      className="fs-one text-decoration-none purple-color fw-bold"
                    >
                      Report pronunciation issue
                    </Link>
                  </div>
                  <small className="text-muted fs-one">
                    This recording and transcript will expire in 89 days
                  </small>
                </div>
              </div>

              {/* Transcript */}
              <div className="py-3 transcript-container">
                <Accordion>
                  <Accordion.Item className="border-0" eventKey="0">
                    <Accordion.Header>
                      <h6 className="fw-bold">Transcript</h6>
                    </Accordion.Header>
                    <Accordion.Body className="px-0 pb-0 pt-4 transcript-body">
                      <div className="transcript-container">
                        {transcriptData.map((entry, index) => (
                          <div
                            key={index}
                            className={`transcript-entry ${
                              entry.speaker === "Naura" ? "ai" : "user"
                            }`}
                          >
                            <small className="text-muted">
                              {new Date(entry.timestamp).toLocaleTimeString(
                                "en-US",
                                { timeZone: "America/Chicago" }
                              )}{" "}
                              <strong className="text-black ms-2">
                                {entry.speaker}
                              </strong>
                            </small>
                            <p className="fs-one mt-2">{entry.message}</p>
                          </div>
                        ))}
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </div>
            </div>
          </div>

          {/* Right Section */}
          <div className="col-md-4 mt-3">
            {/* Caller Info */}
            <div className="card p-4 mb-4 border-light-subtle shadow-sm bg-light-subtle">
              <h6 className="fw-bold">{call.name || "NA"}</h6>
              <small className="gray-color"> {call.status || "NA"}</small>
              <hr className="border-dark-subtle" />
              <p className="mb-1">
                <img
                  src="/assets/clock.svg"
                  alt="Play"
                  className="img-fluid me-2"
                />
                {call.startTime
                  ? new Date(call.startTime).toLocaleString()
                  : "NA"}
              </p>
              <p className="mb-1">
                <img
                  src="/assets/phone-gray.svg"
                  alt="Play"
                  className="img-fluid me-2"
                />
                {call.fromPhoneNumber || "NA"}
              </p>
              <p className="mb-1">
                <img
                  src="/assets/mail.svg"
                  alt="Play"
                  className="img-fluid me-2"
                />
                {call.email || "NA"}
              </p>
              <p className="mb-4">
                <img
                  src="/assets/map-pin-gray.svg"
                  alt="Play"
                  className="img-fluid me-2"
                />
                {call.location || "NA"}
              </p>

              <div className="my-5 px-0">
                <h6 className="fw-bold">Summary sent to</h6>
                <hr className="border-dark-subtle" />
                <p className="text-muted">{call.summarySentTo || "NA"}</p>
              </div>

              <div className="my-4 px-0 call-detail-actions">
                <h6 className="fw-bold">Actions</h6>
                <hr className="border-dark-subtle" />
                <ul className="list-unstyled">
                  <li>
                    <Link className="text-danger fw-bold">Block caller</Link>
                  </li>
                  <li>
                    <Link className="purple-color fw-bold">Mark as test</Link>
                  </li>
                  <li>
                    <Link className="purple-color fw-bold">
                      Send call to voicemail
                    </Link>
                  </li>
                  <li>
                    <Link className="purple-color fw-bold">
                      Add to direct transfer list
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="none"
          className="btn-primary-style"
          onClick={handleClose}
        >
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CallDetails;
